/** Minimal SvelteKit devalue resolver (matches dgdg.app payloads). */
export function resolveDevalue(pool, val, depth = 0, seen = new Set()) {
    if (depth > 28)
        return val;
    if (typeof val === "number" &&
        Number.isInteger(val) &&
        val >= 0 &&
        val < pool.length) {
        if (seen.has(val))
            return val;
        seen.add(val);
        return resolveDevalue(pool, pool[val], depth + 1, seen);
    }
    if (Array.isArray(val)) {
        return val.map((v) => resolveDevalue(pool, v, depth + 1, new Set()));
    }
    if (val && typeof val === "object") {
        const out = {};
        for (const [k, v] of Object.entries(val)) {
            out[k] = resolveDevalue(pool, v, depth + 1, new Set());
        }
        return out;
    }
    return val;
}
/** Alias used by dgdg-parse port and Node scripts. */
export const resolve = resolveDevalue;
